/* tslint:disable */
/* eslint-disable */
/**
 * OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import type {
  CreateDigitalBillAndMoveOrderLinesDto,
  ErrorMessage,
  MoveOrderLinesDto,
  MoveToExistingDigitalBillDto,
} from '../models';
import {
    CreateDigitalBillAndMoveOrderLinesDtoFromJSON,
    CreateDigitalBillAndMoveOrderLinesDtoToJSON,
    ErrorMessageFromJSON,
    ErrorMessageToJSON,
    MoveOrderLinesDtoFromJSON,
    MoveOrderLinesDtoToJSON,
    MoveToExistingDigitalBillDtoFromJSON,
    MoveToExistingDigitalBillDtoToJSON,
} from '../models';

export interface MoveOrderLinesToDigitalBillRequest {
    locationId: string;
    fromReference: string;
    toReference: string;
    moveOrderLinesDto: MoveOrderLinesDto;
}

export interface MoveOrderLinesToNewDigitalBillRequest {
    locationId: string;
    reference: string;
    createDigitalBillAndMoveOrderLinesDto: CreateDigitalBillAndMoveOrderLinesDto;
}

/**
 * 
 */
export class MoveOrderLinesControllerApi extends runtime.BaseAPI {

    /**
     */
    async moveOrderLinesToDigitalBillRaw(requestParameters: MoveOrderLinesToDigitalBillRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<MoveToExistingDigitalBillDto>> {
        if (requestParameters.locationId === null || requestParameters.locationId === undefined) {
            throw new runtime.RequiredError('locationId','Required parameter requestParameters.locationId was null or undefined when calling moveOrderLinesToDigitalBill.');
        }

        if (requestParameters.fromReference === null || requestParameters.fromReference === undefined) {
            throw new runtime.RequiredError('fromReference','Required parameter requestParameters.fromReference was null or undefined when calling moveOrderLinesToDigitalBill.');
        }

        if (requestParameters.toReference === null || requestParameters.toReference === undefined) {
            throw new runtime.RequiredError('toReference','Required parameter requestParameters.toReference was null or undefined when calling moveOrderLinesToDigitalBill.');
        }

        if (requestParameters.moveOrderLinesDto === null || requestParameters.moveOrderLinesDto === undefined) {
            throw new runtime.RequiredError('moveOrderLinesDto','Required parameter requestParameters.moveOrderLinesDto was null or undefined when calling moveOrderLinesToDigitalBill.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request({
            path: `/v1/locations/{locationId}/bookings/{fromReference}/move/{toReference}`.replace(`{${"locationId"}}`, encodeURIComponent(String(requestParameters.locationId))).replace(`{${"fromReference"}}`, encodeURIComponent(String(requestParameters.fromReference))).replace(`{${"toReference"}}`, encodeURIComponent(String(requestParameters.toReference))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: MoveOrderLinesDtoToJSON(requestParameters.moveOrderLinesDto),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => MoveToExistingDigitalBillDtoFromJSON(jsonValue));
    }

    /**
     */
    async moveOrderLinesToDigitalBill(requestParameters: MoveOrderLinesToDigitalBillRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<MoveToExistingDigitalBillDto> {
        const response = await this.moveOrderLinesToDigitalBillRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async moveOrderLinesToNewDigitalBillRaw(requestParameters: MoveOrderLinesToNewDigitalBillRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<MoveToExistingDigitalBillDto>> {
        if (requestParameters.locationId === null || requestParameters.locationId === undefined) {
            throw new runtime.RequiredError('locationId','Required parameter requestParameters.locationId was null or undefined when calling moveOrderLinesToNewDigitalBill.');
        }

        if (requestParameters.reference === null || requestParameters.reference === undefined) {
            throw new runtime.RequiredError('reference','Required parameter requestParameters.reference was null or undefined when calling moveOrderLinesToNewDigitalBill.');
        }

        if (requestParameters.createDigitalBillAndMoveOrderLinesDto === null || requestParameters.createDigitalBillAndMoveOrderLinesDto === undefined) {
            throw new runtime.RequiredError('createDigitalBillAndMoveOrderLinesDto','Required parameter requestParameters.createDigitalBillAndMoveOrderLinesDto was null or undefined when calling moveOrderLinesToNewDigitalBill.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request({
            path: `/v1/locations/{locationId}/bookings/{reference}/move`.replace(`{${"locationId"}}`, encodeURIComponent(String(requestParameters.locationId))).replace(`{${"reference"}}`, encodeURIComponent(String(requestParameters.reference))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: CreateDigitalBillAndMoveOrderLinesDtoToJSON(requestParameters.createDigitalBillAndMoveOrderLinesDto),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => MoveToExistingDigitalBillDtoFromJSON(jsonValue));
    }

    /**
     */
    async moveOrderLinesToNewDigitalBill(requestParameters: MoveOrderLinesToNewDigitalBillRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<MoveToExistingDigitalBillDto> {
        const response = await this.moveOrderLinesToNewDigitalBillRaw(requestParameters, initOverrides);
        return await response.value();
    }

}
